var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index" },
    [
      _c(
        "div",
        { staticClass: "indexNew" },
        [
          _c(
            "el-row",
            { staticClass: "top_box", attrs: { gutter: 24 } },
            [
              _vm.col_1 > 0
                ? _c("el-col", { attrs: { md: _vm.col_1 } }, [
                    _c(
                      "div",
                      { staticClass: "index_top" },
                      [
                        _c(
                          "MyBox",
                          {
                            attrs: { title: "会员待发货订单信息" },
                            on: {
                              refresh: function ($event) {
                                return _vm.refreshFn("orderList")
                              },
                            },
                          },
                          [_c("OrderList", { ref: "orderList" })],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.col_2 > 0
                ? _c("el-col", { attrs: { md: _vm.col_2 } }, [
                    _c(
                      "div",
                      { staticClass: "index_top" },
                      [
                        _c(
                          "MyBox",
                          {
                            attrs: { title: "凤享荟兑付信息" },
                            on: {
                              refresh: function ($event) {
                                return _vm.refreshFn("FxhList")
                              },
                            },
                          },
                          [_c("FxhList", { ref: "FxhList" })],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("el-col", { attrs: { md: _vm.col_3 } }, [
                _c(
                  "div",
                  { staticClass: "index_top" },
                  [
                    _c(
                      "MyBox",
                      {
                        attrs: { title: "消息公告" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("messageTable")
                          },
                        },
                      },
                      [_c("MessageTable", { ref: "messageTable" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { md: _vm.col_4 } }, [
                _c(
                  "div",
                  { staticClass: "index_top" },
                  [
                    _c(
                      "MyBox",
                      {
                        attrs: { title: "待处理" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("todoList")
                          },
                        },
                      },
                      [_c("TodoList", { ref: "todoList" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("el-col", { attrs: { md: 6 } }, [
                _c(
                  "div",
                  { staticClass: "index_bottom" },
                  [
                    _c(
                      "MyBox",
                      {
                        staticClass: "myApp borderStyle",
                        attrs: { title: "我的申请" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("myApply")
                          },
                        },
                      },
                      [_c("MyApply", { ref: "myApply" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { md: 6 } }, [
                _c(
                  "div",
                  { staticClass: "index_bottom" },
                  [
                    _c(
                      "MyBox",
                      {
                        staticClass: "borderStyle",
                        attrs: { title: "企业用户待处理数据" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("user")
                          },
                        },
                      },
                      [_c("User", { ref: "user" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { md: 6 } }, [
                _c(
                  "div",
                  { staticClass: "index_bottom" },
                  [
                    _c(
                      "MyBox",
                      {
                        staticClass: "borderStyle",
                        attrs: { title: "被驳回" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("rejectList")
                          },
                        },
                      },
                      [_c("RejectList", { ref: "rejectList" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { md: 6 } }, [
                _c(
                  "div",
                  { staticClass: "index_bottom" },
                  [
                    _c(
                      "MyBox",
                      {
                        staticClass: "borderStyle",
                        attrs: { title: "即将超期核销数据" },
                        on: {
                          refresh: function ($event) {
                            return _vm.refreshFn("cqhxList")
                          },
                        },
                      },
                      [_c("cqhxList", { ref: "cqhxList" })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "即将超期核销数据",
            visible: _vm.dialogTableVisible,
            "append-to-body": true,
            "modal-append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.gridData,
                border: "",
                "header-cell-style": "background-color: #e8e8e8;color:#606266",
              },
            },
            [
              _c("el-table-column", {
                attrs: { property: "actName", label: "活动名称" },
              }),
              _c("el-table-column", {
                attrs: { property: "actCode", label: "活动编码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#c34231",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleActCodeClick(scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.actCode) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { property: "responseName", label: "负责人" },
              }),
              _c("el-table-column", {
                attrs: { property: "createName", label: "创建人" },
              }),
              _c("el-table-column", {
                attrs: { property: "noAuditAmount", label: "待核销金额" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }